import api from '@/api/common/permission.js'
const state = {
    menuList: [],
	menuTreeList: []
}
const mutations = {
    getMenuList(state, data) {
        state.menuList = data
    },
	getMenuTreeList(state, data) {
	    state.menuTreeList = data
	}
}
const actions = {
	addAccount({}, params = {}) {
        return api.addAccount(params)
	},
    permission({}, params = {}) {
        return api.permission(params)
	},
    getAccountList({}, params = {}) {
        return api.accountList(params)
	},
    async getMenuList({commit}, params = {}) {
        let res = await api.menuList(params) // 获取动态路由菜单栏menu(login/login/menu)
        function getList(data) {
            let arr = []
            data.forEach(item => {
                if(item.children) {
                    let list = getList(item.children)
                    if(list.length) {
                        arr.push(item,...list)
                    }
                } else {
                    arr.push(item)
                }
            })
            return arr
        }
		function treeMenuFilter (data,code){
			 return data.filter(item => {
						return item.level <= code
				 }).map(item => {
					if (item.children) {
						if(item.level >= code){
							delete item.children
						} else {
							item.children = treeMenuFilter(item.children, 2)
						}
					}
					return item
				})
		}
		
		let menusList = [{
		    route_name: '/notFound'
		}]
		if(res.length) {
			menusList = treeMenuFilter(JSON.parse(JSON.stringify(res)),2) 
		}
		commit('getMenuList',  res.length ? res : [{
		    route_name: '/notFound'
		}])
		
		commit('getMenuTreeList', menusList)
        return {
            menuList: res.length ? getList(res): [],
            menuTreeList: res.length ? res : [{
                route_name: '/notFound'
            }]
        }
	},
    getAccountInfo({}, params = {}) {
        return api.accountInfo(params)
	},
    editAccount({}, params = {}) {
        return api.editAccount(params)
	},
    editPermission({}, params = {}) {
        return api.editPermission(params)
	},
    enableAccount({}, params = {}) {
        return api.enableAccount(params)
	},
	accountDel({}, params = {}) {
        return api.accountDel(params)
	}
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}